import {liveServiceV2} from "@data/services/liveServiceV2";
import {apiConstants} from "@data/constants/apiConstants";
import {liveService} from "@data/services/liveService";
import {messengerService} from "@data/services/messengerService";
import {liveKitRoomConstants, liveModeConstants} from "@data/constants/liveModeConstants";

const initialState = {
    roomData:
        {
            video: false,
            audio: false,
            roomName: null,
            token: null,
            shouldUseCallKeep: true,
            serverUrl: "wss://masteur-qw3yjura.livekit.cloud/"
        },
    // Le micro que la salle n'ouvre pas d'elle-même à sa connexion (`LiveKitRoomM`). Seul le live de
    // l'élève du nouvel espace l'écrit (`micGate`) : jamais persisté, effacé avec le token à la sortie.
    microphoneHeld: false,
}

export default function index(state = initialState, action) {
    switch (action.type) {
        case liveKitRoomConstants.HOLD_LIVEKIT_MICROPHONE:
            return !!action.held === state.microphoneHeld ? state : { ...state, microphoneHeld: !!action.held }
        case liveKitRoomConstants.SET_LIVEKIT_TOKEN:
            return {
                ...state,
                roomData: {
                    ...state.roomData,
                    token: action.token,
                    roomName: action.roomName,
                    audio: true,
                    video: true,
                }
            }
        case liveService.leaveLiveSession.name + apiConstants._SUCCESS:
        case liveModeConstants.RESET_LIVE_MODE:
            return initialState
        case messengerService.getMessengerThread.name + apiConstants._SUCCESS:
            return {
                ...state,
                roomData: {
                    ...state.roomData,
                    token: action.data.livekit_token,
                    roomName: action.data.messenger_thread_id ?? null,
                    audio: false,
                    video: false,
                    messengerThreadId: action.data.messenger_thread_id,
                }
            }
        default:
            return state
    }
}
